import { defineStore } from "pinia";

export const useImportModelStore = defineStore('importModel', {
    state: () => ({
        importModel: {},
        importModels: [],
    }),
    actions: {
        setImportModel(importModel) {
            this.importModel = importModel
        },
        setImportModels(importModels) {
            this.importModels = importModels
        },
        addImportModel(importModel) {
            this.importModels.unshift(importModel)
        },
        updateImportModel(importModel) {
            let index = this.importModels.findIndex(cl => cl.id === importModel.id)
            this.importModels.splice(index, 1, importModel)
        },
        deleteImportModel(importModel) {
            let index = this.importModels.findIndex(cl => cl.id === importModel.id)
            this.importModels.splice(index, 1)
        },
    },
});